import { render, staticRenderFns } from "./ApplicantProfile.vue?vue&type=template&id=3280e068&"
import script from "./ApplicantProfile.vue?vue&type=script&lang=js&"
export * from "./ApplicantProfile.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports